import { Box } from '@hivebrite/design-system/Box';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

export const Title = ({ title }: { title: string }) => (
  <Box display="flex" alignItems="center" gridColumnGap={3}>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="primary"
      style={{
        width: '32px',
        height: '32px',
        borderRadius: '50%',
      }}
    >
      <FontAwesomeIcon
        iconName="sparkles"
        iconType={CATEGORIES.SOLID}
        height="16px"
        color="white"
      />
    </Box>
    <Box font="h3-semibold">{title}</Box>
  </Box>
);
